// @flow
import React, { Component } from "react";

import UserAuth from "../../global/containers/UserAuth";
import RedirectoLogin from "../../account/views/RedirectoLogin";
import { AppHeader } from "imagus-components";
import DocumentGenerate from "../containers/DocumentGenerate";

class AuthDocument extends Component<*> {

  render(): * {
    return (
      <UserAuth principal='imagus_admin' unAuthChildren={<RedirectoLogin />} >
        <div className="app-main">
          <AppHeader
            title="Auth Documentation"
            IconName="LibraryBooks"
          />
          <div className="app-panel">
            <div className="app-panel-content">
              <DocumentGenerate endpoint="/auth/v2/documentation" />
            </div>
          </div>
        </div>
      </UserAuth>
    );
  }
}

export default AuthDocument;
